/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const keeta_chain_about = () => `Keeta Network is a high-performance blockchain network that bridges traditional finance and digital assets. Built for scalability, security, and compliance, Keeta enables financial institutions and enterprises to integrate blockchain technology while meeting regulatory requirements.`
